import { render, staticRenderFns } from "./ClinicFees.vue?vue&type=template&id=5307d775&scoped=true"
import script from "./ClinicFees.vue?vue&type=script&lang=js"
export * from "./ClinicFees.vue?vue&type=script&lang=js"
import style0 from "./ClinicFees.vue?vue&type=style&index=0&id=5307d775&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5307d775",
  null
  
)

export default component.exports